import { useTellescopeMutation } from "@tellescope/tanstack-query";
import { useEnduserStore } from "../store/hooks";

interface CancelEventParams {
  eventId: string;
  cancelReason?: string;
}

/**
 * Hook for cancelling calendar events.
 * Sets cancelledAt timestamp and tracks the status change source as "enduser".
 */
export function useCancelCalendarEvent() {
  const session = useEnduserStore((state) => state.session);
  const enduserId = useEnduserStore((state) => state.currentEnduser?.id);

  const mutation = useTellescopeMutation({
    model: "calendar_events",
    method: "updateOne",
    session: session ?? undefined,
    autoCacheUpdateStrategy: "invalidate",
  });

  const cancelEvent = ({ eventId, cancelReason }: CancelEventParams) => {
    return mutation.mutate({
      id: eventId,
      cancelledAt: new Date(),
      cancelReason,
      statusChangeSource: {
        source: "enduser",
        identifier: enduserId ?? "unknown",
      },
    });
  };

  const cancelEventAsync = async ({ eventId, cancelReason }: CancelEventParams) => {
    return mutation.mutateAsync({
      id: eventId,
      cancelledAt: new Date(),
      cancelReason,
      statusChangeSource: {
        source: "enduser",
        identifier: enduserId ?? "unknown",
      },
    });
  };

  return {
    ...mutation,
    cancelEvent,
    cancelEventAsync,
  };
}
